<template>
  <router-view />
</template>

<script>

export default {
  name: 'I18nWrapper'
}
</script>
